import React, {PureComponent, Fragment} from "react";
import "./PhotoProducts.scss";
import PhotoProductModal from "../PhotoProductModal/PhotoProductModal";
import Api from "../../utils/api_calls";
import Common from "../../utils/common";
import Analytics from "../../libs/analytics";
import Carousel from "../Carousel/Carousel";
import ChevronLeft from "mdi-react/ChevronLeftIcon";
import ChevronRight from "mdi-react/ChevronRightIcon";
import ClientConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import store from "../../store/store";
import * as actionType from "../../store/actions";

const responsive = [
    {
        breakpoint: 769,
        settings: {
            slidesToScroll: 1,
            slidesToShow: 1
        }
    },
    {
        breakpoint: 480,
        settings: {
            centerMode: false,
            centerPadding: "0",
            arrows: true,
            slidesToScroll: 1,
            slidesToShow: 1
        }
    }
];

const PrevArrow  =({onClick, style}) => <div onClick={onClick} style={{...style}} className={"tvp-photo-product-arrow tvp-photo-product-prev"}><ChevronLeft size={'40px'}/></div>;
const NextArrow = ({onClick, style}) => <div onClick={onClick} style={{...style}} className={"tvp-photo-product-arrow tvp-photo-product-next"}><ChevronRight size={'40px'}/></div>;
class PhotoProducts extends PureComponent {
    constructor(props) {
        super(props);
        const products = props.products && props.products.length > 0 ? props.products : [];
        this.state = {
            products: products.length > 0 ? [...products, ...this.validateProducts(products.length)] : products,
            hasProducts: products.length > 0,
            modalContent: null,
            modalOpen: false,
            page: 1,
            trigger: false
        };
    }

    openModal = (key) => {
        this.setProductActive(key)
    }
    setProductActive = (key) => {
        const {products} = this.state;
        const {asset, userHashId} = this.props;
        const product = products[key];
        Analytics.productClick(product, product.entityIdParent);
		Analytics._GA_EVENTS('event',{
			'Event_category' : 'videos',
			'Event_action': 'tvp:product:click',
			'Event_label' : product.title
		});
        store.dispatch({
            type: actionType.UPDATE_PRODUCT_MODAL,
            product_modal: {
                modalOpen: true,
                product: product,
                selectedIndex: key,
                enableNext: this.enableNext(products[key + 1]),
                enablePrev: this.enablePrev(products[key - 1]),
                asset: asset,
                userHashId: userHashId
            }
        });
    }

    enableNext(next) {
        if (!next) return false;
        return (next && !next.dummy)
    }

    enablePrev(prev) {
        if (!prev) return false;
        return (prev && !prev.dummy)
    }

    loadProducts = (asset) => {
        const that = this;
        const {products} = this.state;
        if (products.length > 0) return;
        Api.products(Common.getProductsEndpoint(asset)).then(({data}) => {
            let response = data.matches;
            if (!response.length) {
                that.setState({
                    hasProducts: false,
                    products: []
                });
            } else {
                for (let index = 0; index < response.length; index++) {
                    let element = response[index];
                    element.entityIdParent = asset.id;
                    Common.createProductStructureData(element);
                }
                response = response.map(productItem => {
                    return !!productItem.entity ? {...productItem.entity, ...productItem.entity.data} : productItem;
                });
                const dummies = this.validateProducts(response.length);
                that.setState({
                    products: [...response, ...dummies],
                    hasProducts: true
                });

            }
        });
    }

    createDummies(dummiesQty) {
        const dummies = [];
        for (let i = 0; i < dummiesQty; i++) {
            dummies.push({
                dummy: true
            });
        }
        return dummies;
    }

    isVertical = () => window.innerWidth > 991;

    validateProducts(productsQty) {
        //maybe use this function when resize for mobile
        //perPage value minus the total of products to inject the empty squares
        const perPage = 6;
        if (productsQty <= 2) {
            return this.createDummies(2 - productsQty);
            //should change production section with and make photo are bigger to sm-8
        } else if (productsQty <= perPage) {
            return this.createDummies(perPage - productsQty);
        } else {
            const difference = productsQty / perPage;
            const oneBelow = parseInt(difference) * perPage;
            const result = productsQty - oneBelow;
            if (result !== 0)
                return this.createDummies(perPage - result);
            else
                return [];
        }

    }

    componentDidMount() {
        const {asset} = this.props;
        if(asset){
            this.loadProducts(asset)
        }

    }

    getOtherProduct = (next) => {
        this.setProductActive(next)
    }
    render() {
        const {hasProducts, products} = this.state;
        const {ambassador} = this.props;
        const productsQty = products.length > 0 ? products.length : 0;
        const totalPages = productsQty > 2 ? productsQty / 6 : 1;
        const pages = [];
        for (let i = 0; i<totalPages; i++){
            pages.push(i);
        }
        const moreThanTwo = productsQty > 2;
        const customWidth = moreThanTwo ? "col-4 col-lg-6" : "col-6 col-lg-12 two-items";
        return <Fragment>
            <div className={""}>

                <div className={"tvp-product-area " + (moreThanTwo ? "" : "tvp-no-margin")}>
                    <Carousel centerMode={false} prevArrow={<PrevArrow/>} nextArrow={<NextArrow/>} responsive={responsive} enableLine={false} slidesToShow={1}>
                        {
                            hasProducts && pages.map((item, page) => {
                                const skip = page+1 === 1 ? 0 : (((page+1 - 1) * 6));
                                const take = skip + 6;
                                const productsToRender = productsQty > 6 ? products.slice(skip, take) : products;
                                const hideOnMobile = (totalPages === 1 && productsToRender.filter(p => !p.dummy).length === 3) ? "tvp-hide-on-mobile" : '';
                                const CarouselItem = () =>  <div className={"d-flex flex-wrap"} key={page}>
                                    {productsToRender.map((product, key) => {
                                        if(product && product.data && typeof product.data === "string"){
                                            product.data = JSON.parse(product.data);
                                        }
                                        const productKey = page+1 === 1 ? key : ((page+1-1) * 6) + key;
                                        return <div className={"tvp-product-item " + customWidth} key={key}>
                                            <div className={"tvp-photo-product-holder"}>
                                                {!product.dummy ?
                                                    <div className={"embed-responsive embed-responsive-1by1 tvp-photo-product"}
                                                         onClick={() => this.openModal(productKey)}>
                                                        <div className={"embed-responsive-item"}
                                                             style={{backgroundImage: `url(${product.data.imageUrl})`}}>
                                                            <div className={"tvp-buy-now"}>{ClientConfigurationHelper.getProductsCTAText()}</div>
                                                        </div>
                                                    </div> :
                                                    <div className={hideOnMobile}>
                                                        <div
                                                            className={"embed-responsive embed-responsive-1by1 tvp-photo-product-dummy"}>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    })}
                                </div>;

                                return <div key={page}> <CarouselItem/></div>;
                            })
                        }



                    </Carousel>
                </div>

            </div>
            <PhotoProductModal
                ambassador={ambassador}
                getNewProduct={this.getOtherProduct}/>
        </Fragment>
    }
}

export default PhotoProducts;